<tr [formGroup]="suggestionForm" (appClickOutside)="clickedOutside($event)">
    <td class="flex-1">
        <span>{{ suggestion.taskId }}</span>
    </td>
    <td class="flex-3">
        <span>{{ suggestion.patientName }}</span>
    </td>
    <td class="flex-3">
        <span [innerHTML]="suggestion.taskDescription"></span>
    </td>
    <td class="flex-2">{{ suggestion.originalStartTime }} - {{ suggestion.originalEndTime }}</td>
    <td class="flex-2">
        <app-time-picker
            [ngClass]="{
                'has-error': suggestionForm.controls['fromTime'].errors
            }"
            formControlName="fromTime"
            (change)="timeChanged()"
        ></app-time-picker>
        <span class="time-separator"></span>
        <app-time-picker
            [ngClass]="{
                'has-error': suggestionForm.controls['toTime'].errors
            }"
            formControlName="toTime"
            (change)="timeChanged()"
        ></app-time-picker>
    </td>
    <td class="flex-1">
        <app-toggle [id]="suggestion.taskId" [large]="true" formControlName="permanent"></app-toggle>
    </td>
    @if (firstColumnVisible) {
        <td class="flex-1 justify-content-center">
            <app-checkbox [id]="suggestion.taskId" [disable]="true" formControlName="checked"></app-checkbox>
        </td>
    }
    <td class="flex-1 justify-content-center no-top-bottom-padding">
    <span
        class="vismaicon vismaicon-sm vismaicon-refresh vismaicon-reverse mr-2"
        [ngClass]="{ disabled: suggestionForm.pristine && !suggestion.edited }"
        (click)="revert($event)"
    ></span>
        <span
            class="vismaicon vismaicon-sm vismaicon-save"
            [ngClass]="{ disabled: suggestionForm.pristine || suggestionForm.invalid }"
            (click)="save($event)"
        ></span>
    </td>
</tr>
